var map = {
	"./AFSdarkgrey.png": 36,
	"./FPC.png": 37,
	"./Fast.png": 38,
	"./Github.png": 20,
	"./Insta.png": 21,
	"./LinkedIn.png": 22,
	"./OS.png": 39,
	"./Pong.png": 40,
	"./SVT.png": 41,
	"./Sudoku.png": 42,
	"./Twitter.png": 23,
	"./Whitworth.png": 43,
	"./WhitworthMap.png": 44,
	"./WhitworthTF.png": 45,
	"./WhitworthXC.png": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;